/**
 * Background Tasks — E2E Selector Constants
 *
 * data-testid values for all interactive elements in the tasks panel.
 * Import from shared/selectors/ in E2E tests.
 */
export const TASKS_PANEL = {
  // Panel containers
  panel: 'tasks-panel',
  panelFloating: 'tasks-panel-floating',
  panelInline: 'tasks-panel-inline',
  panelSidebar: 'tasks-panel-sidebar',

  // Task items (append taskId)
  itemPrefix: 'task-item-',
  statusPrefix: 'task-status-',
  cancelPrefix: 'task-cancel-',
  navigatePrefix: 'task-navigate-',
  removePrefix: 'task-remove-',
  progressPrefix: 'task-progress-',
  unviewedDotPrefix: 'task-unviewed-',
  phaseStepperPrefix: 'task-phases-',
  phaseItemPrefix: 'task-phase-',
  expandPrefix: 'task-expand-',

  // Filter controls
  filterActive: 'task-filter-active',
  filterCompleted: 'task-filter-completed',
  filterAll: 'task-filter-all',
  filterMine: 'task-filter-mine',
  filterAllMembers: 'task-filter-all-members',

  // Badge
  unviewedBadge: 'task-unviewed-badge',

  // TasksView (fullscreen)
  tasksView: 'tasks-view',
  tasksViewTabs: 'tasks-view-tabs',
  tasksViewTabPrefix: 'tasks-view-tab-',
  tasksViewRowPrefix: 'tasks-view-row-',
  tasksViewDialog: 'tasks-view-dialog',
  tasksViewDialogClose: 'tasks-view-dialog-close',

  // TasksView — bulk delete (SDataTable selection)
  tasksViewDeleteSelected: 'tasks-view-delete-selected',
  tasksViewDeleteConfirm: 'tasks-view-delete-confirm',
  tasksViewDeleteConfirmSubmit: 'tasks-view-delete-confirm-submit',
  tasksViewDeleteResult: 'tasks-view-delete-result',
  tasksViewRowMenuPrefix: 'tasks-view-row-menu-',
  tasksViewRowDeletePrefix: 'tasks-view-row-delete-',
  tasksViewRowDetailsPrefix: 'tasks-view-row-details-',

  // TaskDetailDialog
  taskDetailDialog: 'task-detail-dialog',
  strategyHealthReportSection: 'strategy-health-report-section',
  strategyHealthSummary: 'strategy-health-summary',
  strategyHealthGroup: (checkId: string) => `strategy-health-group-${checkId}`,
  strategyHealthPathTrace: 'strategy-health-path-trace',
  strategyHealthTruncationNote: 'strategy-health-truncation-note',
  healthSeverityGroup: (severity: string) => `health-severity-group-${severity}`,
  healthFindingGo: 'health-finding-go',
  healthFindingRepair: 'health-finding-repair',
  strategyRepairReportSection: 'strategy-repair-report-section',
  strategyRepairReportChecksum: 'strategy-repair-report-checksum',
  strategyRepairReportApproval: 'strategy-repair-report-approval',
  strategyRepairReportAction: (index: number) => `strategy-repair-report-action-${index}`,
  strategyRepairReportTruncation: 'strategy-repair-report-truncation',
  strategyRepairReportFinalHealth: 'strategy-repair-report-final-health',

  // TaskDetailDialog — TaskErrorResolver (G5 / PRE-GP-005). `errorResolverAction`
  // kinds: 'save-again' | 'generate-again' | 'open-strategy' | 'retry'.
  errorResolverMessage: 'task-error-resolver-message',
  errorResolverAction: (kind: string) => `task-error-resolver-action-${kind}`,
  errorResolverResult: 'task-error-resolver-result',

  // TaskDetailDialog — contract-compile failure panel
  // (strategy-intake-feasibility Part B; component lands in a later task).
  contractCompilePanel: 'task-error-contract-compile-panel',
  contractCompileOpenStrategy: 'task-error-contract-compile-open-strategy',
  contractCompileRepair: 'task-error-contract-compile-repair',

  // TaskTypeFilter
  taskTypeFilter: 'task-type-filter',
  taskTypeChipPrefix: 'task-type-chip-',

  // TasksSidebarPanel
  sidebarPanel: 'tasks-sidebar-panel',
  sidebarTabInProgress: 'tasks-sidebar-tab-inProgress',
  sidebarTabComplete: 'tasks-sidebar-tab-complete',
  sidebarExpand: 'tasks-sidebar-expand',
  sidebarFullscreen: 'tasks-sidebar-fullscreen',
  markAllViewed: 'tasks-mark-all-viewed',
} as const;
